module.exports = __webpack_public_path__ + "static/media/TCS.94b6c9f7.jpg";